<template>
  <section class="casino-lobby" data-t="casino-lobby-z92m">
    <div class="casino-lobby-inner" data-t="casino-lobby-inner-rwrj">
      <ClientOnly>
        <Teleport to="#casino-filters">
          <CategoryFilters
            v-model:provider="providerCode"
            v-model:theme="categoryTheme"
            v-model:favorite="isFavorite"
            :parent-code="categoryCode"
            data-t="filters"
          />
        </Teleport>
      </ClientOnly>
      <div class="casino-lobby-sliders" data-t="casino-lobby-sliders-8yqp">
        <template v-if="isLoading">
          <CategoryGamesSliderSkeleton v-for="item in 3" :key="item" />
        </template>
        <template v-else>
          <GamesSlider
            v-if="mainCategoryData"
            :key="categoryCode"
            :title="mainCategoryData.name ?? ''"
            :games="mainCategoryData.games"
            :games-total-count="mainCategoryData.gamesTotal"
            :link="`/casino/categories/${categoryCode}/all`"
            :icon-link="mainCategoryData.iconLink ?? undefined"
          />
        </template>
      </div>
      <template v-if="isPageReady">
        <PageTournamentCard
          v-if="tournament"
          :card="tournament"
          data-t="main-page-tournament"
        />
        <div
          v-if="!hasGames && !isLoading && isMounted"
          class="no-games"
          data-t="no-games-nl76"
        >
          <StIcon name="filter-solid" class="no-games-icon" :size="40" />
          {{ t('casino.noGamesFoundbyFilters') }}
        </div>
        <template v-else>
          <ProvidersSlider class="providers" data-t="main-page-providers" />
          <div class="second-categories" data-t="second-categories-t3ey">
            <GamesSlider
              v-for="category in otherCategoriesData"
              :key="category.code"
              :title="category.name ?? ''"
              :code="category.code"
              :games="category.games"
              :games-total-count="category.gamesTotal"
              :link="`/casino/categories/${categoryCode}/${category.code}`"
              :icon-link="category.iconLink ?? undefined"
              data-t="other-category"
              :row="1"
            />
          </div>
        </template>
        <LastBets
          v-if="isVisible"
          :tabs="lastBetsTabs"
          data-t="main-last-bets"
        />
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useIsOnMounted } from '@st/use/composables'
import { useCasinoOverview } from './useCasinoOverview'
import CategoryFilters from '../CategoryPage/parts/CategoryFilters.vue'
import CategoryGamesSliderSkeleton from '../CategoryGamesSlider/CategoryGamesSliderSkeleton.vue'
import LastBets from '../LastBets/LastBets.client.vue'
import { useLastBets } from '../../composables/useLastBets'

const {
  categoryTheme,
  providerCode,
  categoryCode,
  tournament,
  isLoading,
  isFavorite,
  hasGames,
  mainCategoryData,
  otherCategoriesData,
} = useCasinoOverview()

const { tabs: lastBetsTabs, isVisible } = useLastBets('casino')

const { isMounted } = useIsOnMounted()

const { t } = useI18n()

/* отложить загрузку второстепенных компонентов */
const isPageReady = ref(import.meta.env.STORYBOOK ?? false)
onNuxtReady(() => {
  isPageReady.value = true
})
</script>

<style scoped>
.casino-lobby {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-600);

  min-height: 50vh;
  margin-bottom: var(--spacing-600);
}

.casino-lobby-sliders {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-400);
}

.casino-lobby-inner {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-600);
}

.second-categories {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-200);
}

.no-games {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-400);
  align-items: center;
  justify-content: center;

  padding: var(--spacing-600) 0;

  font: var(--desktop-text-md-medium);
  color: var(--text-tertiary);
  text-align: center;
}
</style>
